export default function () {
    $(document).ready(function () {
        const $backToTop = $('#back-to-top');

        $(window).on('scroll', function () {
            if ($(this).scrollTop() > 100) {
                $('#back-to-top').addClass('show');
            } else {
                $('#back-to-top').removeClass('show');
            }
        });

        $backToTop.on('click', function () {
            $('html, body').animate({ scrollTop: 0 }, 600);
            return false;
        });
    });
}
